export function ProductStockTransfersCtrl (
  $scope
) {
  $scope.showTransfers = !!$scope.transfers.length;

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'description',
        header : {
          text: 'Description'
        }
      },
      {
        classes: 'text-left',
        field  : 'created_on',
        header : {
          text: 'Created On'
        },
        pipe: 'globalDate'
      }
    ],
    empty: {
      text: 'No Stock Transfers'
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };
};